import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-link',
  templateUrl: 'form-link.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FormLinkComponent extends FieldBaseComponent {}
